/**
 * Yazıcı komutu üretirken kullanılan byte yardımcıları.
 *
 * Komutlar ASCII metin, grafik verisi ham byte; ikisini aynı akışta birleştirmek
 * gerektiği için her encoder aynı üç işi yapıyordu.
 */

/** ASCII metni byte dizisine çevirir */
export function ascii(text: string): Uint8Array {
  const out = new Uint8Array(text.length);
  for (let i = 0; i < text.length; i++) out[i] = text.charCodeAt(i) & 0xff;
  return out;
}

/** Sayıyı sabit haneli sıfır dolgulu metne çevirir */
export function pad(value: number, digits: number): string {
  return String(Math.max(0, Math.round(value))).padStart(digits, '0');
}

export function concat(chunks: Uint8Array[]): Uint8Array {
  const total = chunks.reduce((sum, c) => sum + c.length, 0);
  const out = new Uint8Array(total);
  let pos = 0;
  for (const c of chunks) {
    out.set(c, pos);
    pos += c.length;
  }
  return out;
}

export function clamp(value: number, min: number, max: number): number {
  return Math.min(max, Math.max(min, Math.round(value)));
}
